import KilometerValue from '@/features/common/components/KilometerValue';
import { InconsistentValue } from '@/features/maintenance-data/components/InconsistentValue';
import { MaintenanceDataItem } from '@/generated/GeneratedApiTypes';

const INCONSISTENT_DUE_IN_TOOLTIP =
    'intl-msg:vehicle-diagnostics.maintenance.table.maintenance-data.inconsistent-due-in';

export const DueInCell = ({ row }: { row: MaintenanceDataItem }) => {
    const { due_in: dueIn } = row;
    if (typeof dueIn?.value !== 'number') {
        return (
            <td data-field="due_in">
                <span>-</span>
            </td>
        );
    }
    const mileage = <KilometerValue value={dueIn.value} />;
    return (
        <td data-field="due_in">
            {dueIn.is_inconsistent ? (
                <InconsistentValue tooltipKey={INCONSISTENT_DUE_IN_TOOLTIP}>{mileage}</InconsistentValue>
            ) : (
                mileage
            )}
        </td>
    );
};
